module.exports = __webpack_public_path__ + "static/media/pdf.841d0cb2.svg";